import Link from "next/link";
import Image from 'next/image'
import React, {useState} from "react";
import {css} from "@emotion/react";
import {useSelector} from "react-redux";

// components
import {Grid, Typography} from "@material-ui/core";

// resources
import DummyImage from "~/images/common/loader.gif"
import { dataSortCategories, dataSortOrders, itemDataUnit } from '../../../../data/shop/itemSearchOption'
import {convertItemImagePath} from "../../../../stores/tools/commons";
import TempFrozen from "../../../../../public/images/common/temperature_frozen.svg";
import TempNormal from "../../../../../public/images/common/temperature_normal.svg";
import styled from "@emotion/styled";
import colorPalette from "../../../../styles/theme/colorPalette";

export const ItemSetCard = (props) => {
  const { name, code, stock_id, ...data } = props.data
  
  const [selectImage, setSelectImage] = useState(0);
  
  const placeholder = 'data:image/gif;base64,R0lGODlhGQAZALMAAP///+fn58/Pz7m5uaGhoZ+fn52dnYmJiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwCAAIAFQAVAAAERRDJSQG9+NrMa6cBtlFGFnpkd0ojUn7r+H7IKs10rn9C7wsZg3CI2xmPg0tBl5QQJstP00mJZqbU6hXzVOq6x2wYAc5EAAAh+QQFBwAIACwCAAIAEgASAAAELxDJSQO9WNrM0eYC9k0AFVZXeZ0apWLs92asNHd4jg18P+jAoJAgRBCHxWNQmYsAACH5BAUHAAgALAIAAgAVAAsAAAQoEMlJBb342sxrpwO2UUEWemR3SiNSfuv4fsgqzXSuf0TvExmAcAiIAAAh+QQFBwAIACwFAAIAEgASAAAELhDJiQa9WNrMa0cEtlECFVKjVF6nRnLtuMLX/N14fgV8H+jAIAIgHBaJQmRQGQEAIfkEBQcACAAsDAACAAsAFQAABCqQoEmrrPhiqung2Ad6GblN4qmup+C+AitXwQlQNXbjOpZPOxolaGMRNxEAIfkEBQcACAAsBQAFABIAEgAABC4QyUkpqbjezDfH3meJZGlyQ6oOZ0sClSDCUjDJGV1TOKXvPB/GFhMRW8dTEhMBACH5BAUHAAgALAIADAAVAAsAAAQnEMgJkL2I6E2w/2AojoE3jFdpCddJYmwrqlcsf3T9uaiNfr4fbBQBACH5BAkHAAgALAIAAgAVABUAAAQzEMlJq7046w227h4GhtZIUuaprlPgvgErz5ZQEaEtDROu6TuK7wIMCokW3i2kZDVXT0sEADs='
  const searchOptionState = useSelector((state) => state.itemSearchOption)

  return(
      <Grid item xs={12} sm={4} md={6} lg={4}>
        <div css={itemBox}>
          <div css={codeAndTemp}>
            <CatalogCode temp={data.shipping_temperature}>
              <span>{ code }</span>
            </CatalogCode>
            <div css={tmpIcon}>
              {
                data.shipping_temperature === '冷凍' &&
                <TempFrozen />
                || data.shipping_temperature === '常温' &&
                <TempNormal />
              }
            </div>
          </div>
          {
            name !== ' ' &&
            dataSortCategories[searchOptionState.sortCategoryIndex].code !== 'code' &&
            <Typography>
              {
                dataSortCategories[searchOptionState.sortCategoryIndex].label
              }
              {
                data[dataSortCategories[searchOptionState.sortCategoryIndex].code] || '-'
              }
              {
                itemDataUnit[searchOptionState.sortCategoryIndex].unit
              }
            </Typography>
          }
          <div css={itemImage}>
            <div css={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div css={{flexBasis: '100%', maxWidth: '192px'}}>
                <Link
                    href={{
                      pathname: '/items/select_sets/[catalogCode]',
                      query: {catalogCode: code},
                    }}
                    prefetch={false}
                >
                  <a>
                    {
                      data.items && data.items[selectImage] &&
                      <Image src={ convertItemImagePath(data.items[selectImage].stock_id, 't1') } width={192} height={192} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder}/>
                    }
                  </a>
                </Link>
              </div>
              <div>
                <Typography css={itemName}>
                  <Link href={{
                    pathname: '/items/select_sets/[catalogCode]',
                    query: {catalogCode: code},
                  }}>
                    <a>
                      {
                        name
                      }
                    </a>
                  </Link>
                </Typography>
                <div css={price}>
                  {`¥ ${data.discount_price && Number(data.discount_price).toLocaleString() || '-'}`}
                </div>
              </div>
              <div css={{flex: 1}}>
                {
                  data.items &&
                  <div css={{display: 'flex', flexWrap: 'wrap'}}>
                    {
                      // data.items.slice(1).map((item) => (
                      //     <div key={item.stock_id} css={{width: `calc(100% / ${(data.items.length / 2 ) + ((data.items.length % 2) === 0 ? 0 : 1)})`}}>
                      //       <Image src={ convertItemImagePath(item.stock_id, 't1') } width={100} height={100} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder}/>
                      //     </div>
                      // ))
                      data.items.map((item, i) => (
                          <div key={`${item.stock_id}_${i}`} css={{width: '25%'}}>
                            <Image src={ convertItemImagePath(item.stock_id, 't1') } width={100} height={100} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder} onClick={() => setSelectImage(i)}/>
                          </div>
                      ))
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </Grid>
  )
}

const itemBox = css`
  padding: 16px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 4%);
  border-radius: 16px;
  min-height: 260px;
  height: 100%;
  position: relative;
  overflow: hidden;
`

const catalogCode = css`
  min-height: 2rem;
`

const itemName = css`
  min-height: 2rem;
`

const itemImage = css`
  margin-top: 8px;
  min-width: 100px;
  min-height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1;
  div {
    border-radius: 8px;
    padding: 4px;
  }
  img {
    margin: 4px;
    transition: transform;
    transition-duration: 0.2s;
  }
  img:hover {
    transform: scale(1.2);
  }
`

const CatalogCode = styled.div({
  minHeight: '2rem',
  color: 'white',
  width: '7rem',
  textAlign: 'center',
  borderRadius: '0 20px 20px 0',
  paddingRight: '2px',
  lineHeight: '1.6',
}, props => ({
  backgroundColor: props.temp === '冷凍' ? colorPalette.temperature.frozen : props.temp === '常温' ? colorPalette.temperature.normal : colorPalette.temperature.normal,
}))

const codeAndTemp = css`
  display: flex;
`

const tmpIcon = css`
  width: 24px;
  height: 24px;
  margin-left: 1rem;
`
const price = css`
  //position: absolute;
  //bottom: 12px;
  //right: 18px;
  text-align: right;
  font-size: 1.6rem;
`